interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  radius?: string;
  style?: Record<string, string | number>;
}

export function Skeleton({ width = '100%', height = 14, radius, style }: SkeletonProps) {
  return (
    <span
      class="skeleton"
      style={{ display: 'block', width, height, borderRadius: radius, ...style }}
    />
  );
}

export function CardSkeleton() {
  return (
    <div class="card">
      <div class="row" style={{ marginBottom: 8 }}>
        <Skeleton width="55%" height={16} />
        <Skeleton width={64} height={20} radius="999px" />
      </div>
      <Skeleton width="75%" height={12} />
    </div>
  );
}

export function KpiSkeleton({ dt }: { dt: boolean }) {
  return (
    <div class={dt ? 'kpi-card' : 'card'} style={{ textAlign: 'center' }}>
      <Skeleton width={40} height={dt ? 28 : 24} style={{ margin: '0 auto 8px' }} />
      <Skeleton width="60%" height={12} style={{ margin: '0 auto' }} />
    </div>
  );
}

export function ListSkeleton({ count = 3 }: { count?: number }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <CardSkeleton key={i} />
      ))}
    </>
  );
}
